var React = require('react');

function SmileyHappy (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14.25 18a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0zm17.25-2.25a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zM10.556 31.088c3.68 7.424 12.681 10.462 20.106 6.782a15.001 15.001 0 006.782-6.782 1.5 1.5 0 10-2.688-1.332 12.001 12.001 0 01-5.426 5.426c-5.94 2.944-13.142.514-16.086-5.426a1.5 1.5 0 10-2.688 1.332z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 24C0 10.746 10.746 0 24 0s24 10.746 24 24-10.746 24-24 24S0 37.254 0 24zM24 3C12.402 3 3 12.402 3 24s9.402 21 21 21 21-9.402 21-21S35.598 3 24 3z","key":1})]);
}

SmileyHappy.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = SmileyHappy;

SmileyHappy.default = SmileyHappy;
